__turbopack_context__.v({
  "filter": "sidebar-casino-filter-module-sass-module__SaJQrq__filter",
  "selected": "sidebar-casino-filter-module-sass-module__SaJQrq__selected",
});
